module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-23.404e5b59.png";